import { useTranslations } from "next-intl";
import { useState } from "react";
import { putFeedback } from "@utils/call-api/feedbacks-call";
import Button from "@components/core/Button";
import Textarea from "@components/core/Textarea";

function SwapUserFeedbackComment({
  feedbackId, displayCommentModalContent, hideFeedback,
}) {
  const t = useTranslations("feedbacks");

  const [comment, setComment] = useState("");

  async function sendFeedbackComment(event) {
    event.preventDefault();

    try {
      await putFeedback(feedbackId, comment);
    } finally {
      hideFeedback();
    }
  }

  return (
    <div className={displayCommentModalContent ? "swap-feedback-content-comment" : "d-none"}>
      <div className="swap-feedback-title mb-2">{t("how_to_improve_our_offer")}</div>
      <form className="swap-feedback-form" onSubmit={sendFeedbackComment}>
        <Textarea
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          placeholder={t("feedback_placeholder")}
        />
        <div className="d-flex w-100 justify-content-between">
          <Button
            variant="ghost-dark"
            onClick={hideFeedback}
            className="ms-n3"
          >
            {t("skip_btn")}
          </Button>
          <Button
            type="submit"
            variant="primary"
            disabled={comment === ""}
          >
            {t("send_btn")}
          </Button>
        </div>
      </form>
    </div>
  );
}

export default SwapUserFeedbackComment;
